module Widgets.Signature.Pad where

import Common

import Concur.React.DOM as D
import Concur.React.Props (ReactProps)
import Concur.React.Props as P
import Control.MultiAlternative (class MultiAlternative)
import Control.Promise (Promise, toAff)
import Control.ShiftMap (class ShiftMap)
import React (ReactClass, ReactElement, unsafeCreateElement)
import React.DOM.Props as RDP
import Web.File.Blob (Blob)

-- | Opaque JavaScript type which stores a png image of a signature as a binary blob.
type Signature = Blob

foreign import classSignaturePad :: forall a. ReactClass a

-- | Renders a signature pad.
signaturePad :: forall a b.
    ShiftMap (Widget (Array ReactElement)) b
    => MultiAlternative b
    => Array (ReactProps a)
    -> b a
signaturePad props =
    (D.el' (unsafeCreateElement classSignaturePad <<< RDP.unsafeFromPropsArray)) props []

-- | Custom prop to pass a blob to the signature pad.
initialSignature :: forall a. Signature -> ReactProps a
initialSignature = P.unsafeMkProp "sigBlob"


-- | Extracts the signature as a binary blob from the signature pad with the given HTML ID.
getCanvasBlob :: String -> Aff Signature
getCanvasBlob id = toAff $ getCanvasBlobFromId id

foreign import getCanvasBlobFromId :: String -> Promise Signature

clearCanvas :: String -> Effect Unit
clearCanvas = clearCanvasFromId

foreign import clearCanvasFromId :: String -> Effect Unit

canvasHasInk :: String -> Effect Boolean
canvasHasInk = canvasHasInkFromId

foreign import canvasHasInkFromId :: String -> Effect Boolean


signatureImage :: forall a. Array (ReactProps a) -> Signature -> Widget HTML a
signatureImage props sig = D.img (props <> [ P.src $ signatureDataUrl sig ])

-- | Converts a `Signature` blob into a base-64 encoded image URL that can be
-- | placed in an `img` tag.
foreign import signatureDataUrl :: Signature -> String
